// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_iu-0";
export var fileCarousel = "_iu-2";
export var removeFileButton = "_iu-1";